<template>
  <div class="tables">
    <el-tabs type="border-card" v-model="editableTabsValue">
      <el-tab-pane label="其他文书" name="CVU">
        <tab_six_cvu></tab_six_cvu>
      </el-tab-pane>
      <el-tab-pane label="CV" name="CV">
        <tab_six_cv></tab_six_cv>
      </el-tab-pane>
      <el-tab-pane label="RL">
        <tab_six_rl></tab_six_rl>
      </el-tab-pane>
      <el-tab-pane label="PS">
        <tab_six_ps></tab_six_ps>
      </el-tab-pane>
      <el-tab-pane label="奖学金" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
        <tab_six_jxj></tab_six_jxj>
      </el-tab-pane>
      <el-tab-pane label="SOP" v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
        <tab_six_sop></tab_six_sop>
      </el-tab-pane>
      
      <el-tab-pane label="RP" name="RP"  v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
        <tab_six_rp></tab_six_rp>
      </el-tab-pane>
      <el-tab-pane label="海套" name="TC"  v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
        <tab_six_tc></tab_six_tc>
      </el-tab-pane>
      <el-tab-pane label="深套" name="TCS"  v-if="this.bindInfo.apply_academic_degree.includes('博士学位') ||
        this.bindInfo.apply_academic_degree.includes('申请博士') ||
        this.bindInfo.apply_academic_degree.includes('申请研究型硕士') ||
        this.bindInfo.apply_academic_degree.includes('研究型硕士学位') ">
        <tab_six_tcs></tab_six_tcs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>

import tab_six_cvu from "./tab_six_cvu";
import tab_six_cv from "./tab_six_cv";
import tab_six_rl from "./tab_six_rl";
import tab_six_ps from "./tab_six_ps";
import tab_six_jxj from "./tab_six_jxj.vue";
import tab_six_sop from "./tab_six_sop.vue";
import tab_six_rp from "./tab_six_rp";
import tab_six_tc from "./tab_six_tc";
import tab_six_tcs from "./tab_six_tc_s";

export default {
  name:"TabFive",
  components: {
    tab_six_cv,
    tab_six_cvu,
    tab_six_rl,
    tab_six_ps,
    tab_six_jxj,
    tab_six_sop,
    tab_six_rp,
    tab_six_tc,
    tab_six_tcs
  },
  data () {
    return {
      editableTabsValue: 'CVU'
    };
  },
  created () {
    this.bindInfo = this.$store.state.userAbroad.userAbroadData;
  },
  methods: {

  },
  computed: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_five.vue